import { OptionHeader } from '@fjordline/styles-v3'
import { styled } from 'styled-components'

export const OptionHeaderWrapper = styled.div`
  .selected {
    border-bottom: 4px solid var(--color-fl-ocean);
  }

  .option-header {
    border-bottom: 1px solid var(--color-fl-border-color);
  }

  .option-header > div {
    padding: 0;
    margin-right: var(--spacing-L);
  }

  .option-header h3 {
    font-family: var(--font-source_sans);
    margin: 0;
  }
`;